import './brand-wall.scss';

class BrandWall {
    constructor ($brandWall) {
        this.$brandWall = $brandWall;
    }

    init () {
        this.checkImageOrientation();
    }

    checkImageOrientation () {
        const $logos = this.$brandWall.querySelectorAll('[data-brand-wall="logo"]');

        for (let i = 0; i < $logos.length; i++) {
            const $logo = $logos[i];
            const $image = $logo.querySelector('img');

            if ($image) {
                $image.onload = () => {
                    const height = $image.height;
                    const width = $image.width;

                    if (height > width) {
                        $logo.classList.add('brand-wall__logo--portrait');
                    } else {
                        $logo.classList.add('brand-wall__logo--landscape');
                    }
                };
            }
        }
    }
}

export { BrandWall };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $brandWall = $context.querySelectorAll('[data-brand-wall="root"]');

        for (let i = 0; i < $brandWall.length; i++) {
            const $$brandWall = new BrandWall($brandWall[i]);
            $$brandWall.init();
        }
    }
});
